import countries from '../../../../../lib/service/payment/data/countries.json';

export default {
  format(address) {
    if (!address || !address.country) {
      return '';
    }
    const addressLine = [];
    addressLine.push(`${address.line1} ${address.line2}`);
    addressLine.push(`${address.city}, ${address.state} ${address.zip}`);
    addressLine.push(
      countries[address.country] ? countries[address.country] : address.country
    );
    return addressLine.join('\n');
  }
};
